export const getDeleteCurrencyDefaultPaymentMethodModalId = (currencyCode: string, paymentMethodId: string) =>
  `${currencyCode}-${paymentMethodId}-delete-currency-default-payment-method-modal`
